"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckboxGroup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _constants = require("./constants");

var _types = require("../../types");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxGroup = function CheckboxGroup(props) {
  var options = props.options,
      horizontal = props.horizontal,
      className = props.className,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      value = props.value,
      size = props.size,
      groupProps = _objectWithoutProperties(props, ["options", "horizontal", "className", "defaultValue", "onChange", "value", "size"]);

  var _useState = (0, _react.useState)(props.children),
      _useState2 = _slicedToArray(_useState, 2),
      children = _useState2[0],
      setChildren = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  var optionsWithChecked = (0, _react.useMemo)(function () {
    return (0, _utils.transformOptions)(options).map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        checked: value.find(function (item) {
          return item === option.value;
        }) !== undefined
      });
    });
  }, [options, value]);
  (0, _react.useEffect)(function () {
    setValues(optionsWithChecked);
  }, [optionsWithChecked]);
  var onChangeHandlar = (0, _react.useCallback)(function (value, checked) {
    var mappedValues = values.map(function (item) {
      return item.value === value ? _objectSpread(_objectSpread({}, item), {}, {
        checked: checked
      }) : item;
    });
    setValues(mappedValues);
    onChange(mappedValues.filter(function (item) {
      return item.checked;
    }).map(function (item) {
      return item.value;
    }));
  }, [onChange, values]);
  (0, _react.useEffect)(function () {
    if (values) {
      var _children = values.map(function (checkboxProps, index) {
        return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
          key: (0, _utils.createUniqueKey)(index, checkboxProps.label),
          size: size
        }, checkboxProps, {
          defaultChecked: defaultValue.find(function (item) {
            return item === checkboxProps.value;
          }),
          onChange: function onChange(event) {
            return onChangeHandlar(checkboxProps.value, event.target.checked);
          }
        }));
      });

      setChildren(_children);
    }
  }, [values, onChangeHandlar, defaultValue]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, groupProps, {
    className: (0, _utils.getClassNames)(className, 'checkbox-group', {
      'checkbox-group-horizontal': horizontal
    })
  }), children);
};

exports.CheckboxGroup = CheckboxGroup;
CheckboxGroup.propTypes = {
  /** Default selected value */
  defaultValue: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Disable all checkboxes */
  disabled: _propTypes.default.bool,

  /** The name property of all input[type="checkbox"] children */
  name: _propTypes.default.string,

  /** Specifies options */
  options: _types.optionsList,

  /** The size of checkboxes */
  size: _propTypes.default.oneOf(_constants.CHECKBOX_SIZES),

  /** Enable horizontal view */
  horizontal: _propTypes.default.bool,

  /** The callback function that is triggered when the state changes */
  onChange: _propTypes.default.func,

  /** @ignore */
  children: _propTypes.default.node,

  /** @ignore */
  className: _propTypes.default.string,

  /** Used for setting the currently selected value. */
  value: _propTypes.default.arrayOf(_propTypes.default.string)
};
CheckboxGroup.defaultProps = {
  defaultValue: [],
  disabled: false,
  name: null,
  options: [],
  size: _constants.CHECKBOX_SIZE_DEFAULT,
  horizontal: false,
  onChange: function onChange() {},
  children: null,
  className: null,
  value: []
};
var _default = CheckboxGroup;
exports.default = _default;